import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CircularProgress } from "@mui/material";
import InputField from '../../components/inputField/InputField';
import Button from '../../components/button/Button';
import Message from '../../components/message/Message';
import Footer from '../../components/footer/Footer';
import './VerifyOtpPage.css';
import { useAuth } from '../../components/AuthProvider'; 
import Logo from "../../components/logo/Logo";

const VerifyOtpPage = () => {
    const [otpCode, setOtpCode] = useState('');
    const [message, setMessage] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { verifyOtpAction, resendOtpAction, loadingSuccess } = useAuth();

    const userId = location.state?.userId;

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        if (otpCode.length === 4) {
            const verificationData = {
                id: userId,
                otpCode: otpCode,
            };
            const response = await verifyOtpAction(verificationData);
            if (response && response.status === 200) {
                navigate('/home');
            } else {
                setMessage({ text: 'Código de verificación no válido, Inténtalo nuevamente,', type: 'error' });
            }
        } else {
            setMessage({ text: 'Por favor, ingresa un código de 4 dígitos.', type: 'warning' });
        }
    };

    const handleCloseMessage = (e) => {
        setMessage(null); 
    };

    const handleResendOtp = async (e) => {
        e.preventDefault();
        const response = await resendOtpAction(userId);
        if (response && response.status === 200) {
            setMessage({ text: 'El código de verificación ha sido reenviado.', type: 'success' });
        } else if (response && response.status === 406) {
            setMessage({ text: 'Número máximo de intentos alcanzado.', type: 'error' });
        } else {
            setMessage({ text: 'Ocurrió un inconveniente al reenviar el código, Inténtalo nuevamente,', type: 'error' });
        }
    };

    const isFormValid = otpCode.trim() !== "" && otpCode.length === 4;

    return (
        <div className="login-page-container">
            <div className="login-logo-container">
                <Logo />
            </div>
            <div className="login-form-container">
                <form onSubmit={handleVerifyOtp}>
                    <div>
                        <div>
                            <h3 class="title-login">Código de acceso</h3>
                        </div>
                        <div>
                            <h5 class="subtitle-login">PASO 3 : INGRESA EL CÓDIGO DE ACCESO QUE<br></br>TE HEMOS ENVIADO POR MENSAJE DE TEXTO<br></br>O WHATSAPP A TU CELULAR</h5>
                        </div>
                        <InputField
                            placeholder="Código de verificación (4 dígitos)"
                            type="number"
                            value={otpCode}
                            onChange={(e) => setOtpCode(e.target.value)}
                            maxLength="4"
                        />
                        {message && (
                            <div className="message-container">
                                <Message text={message.text} type={message.type} onClose={handleCloseMessage} />
                            </div>
                        )}
                        <div>
                        <Button type="submit" disabled={loadingSuccess || !isFormValid}>
                            {loadingSuccess ? <CircularProgress size={24} /> : "INGRESAR"}
                        </Button>
                        </div>
                    </div>
                </form>
                <div className="resend-otp-container">
                    <p class="resend-sub">¿No lo recibiste?</p>
                    <button type="button" onClick={handleResendOtp} className="resend-otp-link">
                        Reenviar código
                    </button>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default VerifyOtpPage;